import { amber, grey, red } from '@material-ui/core/colors'
import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  paper: {
    borderRadius: 12,
  },
  titleRoot: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    alignItems: 'flex-start',
    padding: theme.spacing(3, 3, 1, 3),
  },
  content: {
    padding: theme.spacing(0, 3, 0, 3),
    maxHeight: 420,
    overflowY: 'auto',
  },
  groupHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: grey[50],
    borderRadius: 8,
    padding: theme.spacing(1.5, 2),
    marginTop: theme.spacing(2),
    border: `1px solid ${red[50]}`,
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: grey[100],
    },
  },
  groupHeaderTitle: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  groupHeaderIconError: {
    color: red[700],
  },
  groupName: {
    fontWeight: 600,
    fontSize: 15,
  },
  list: {
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${grey[200]}`,
    borderRadius: 8,
    overflow: 'hidden',
  },
  listItem: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    '&:nth-child(even)': {
      backgroundColor: grey[50],
    },
  },
  listItemWarningIcon: {
    minWidth: 36,
    color: amber[700],
  },
  listItemErrorIcon: {
    minWidth: 36,
    color: red[700],
  },
  secondaryText: {
    color: theme.palette.text.secondary,
  },
  actions: {
    padding: theme.spacing(0, 3, 3, 3),
    marginTop: theme.spacing(3),
  },
}))
